import { asapScheduler, of, } from "rxjs";
import { concatMap } from "rxjs/operators";
export function reschedule(scheduler = asapScheduler) {
    return concatMap((value) => of(value, scheduler));
}
//# sourceMappingURL=reschedule.js.map